import { useRouter } from 'next/router';
import { addQueryParams, removeQueryParams } from '@/Framework/Router/nextRouter';
import { usePageFiltersContext } from '@/finsight/application/PageFilters/PageFiltersContext';
import { mapArticleTypeToTitle } from '@/finsight/ui/components/creditFlow/articles/constants';
import { ThemeType } from '@/finsight/domain/vo/CreditFlow/Articles/themeTypes';
import normalizeWhitespace from '@/Framework/dataHelpers/string/normalizeWhitespace';
import { USOA_REGION_ID } from '@/finsight/domain/Region';

const mapTypeToUrl = {
  [ThemeType.commentary]: '/commentary',
  [ThemeType.dealFlow]: '/deal-flow',
};

const getRegionName = (region) => (region.id === USOA_REGION_ID ? region.shortDisplayName : region.abbreviation);

export const useGetLinkToAllArticles = (themeType: ThemeType) => {
  const { query } = useRouter();
  const { firstRegion, firstProduct, includedProductIds, includedRegionIds } = usePageFiltersContext();

  const tooltipRegionName = includedRegionIds.length === 1 ? getRegionName(firstRegion) : '';
  const tooltipProductName = includedProductIds.length === 1 ? firstProduct.abbreviation : '';
  const tooltip = `Go to ${ tooltipRegionName } ${ tooltipProductName } ${ mapArticleTypeToTitle[themeType] }`;

  const newQuery = addQueryParams(query, {
    products: firstProduct.abbreviation,
    regions: firstRegion.abbreviation,
  });

  return {
    link: {
      pathname: `${ mapTypeToUrl[themeType] }-all`,
      query: removeQueryParams(newQuery, ['routeType']),
    },
    tooltip: normalizeWhitespace(tooltip),
  };
};
